<script lang="ts">
	let {
		propertyDescription = "No description provided for this property."
	}: { propertyDescription?: string | null } = $props();
</script>

<!-- Property Description -->
<div id="property-description" class="mb-8">
	<h2 class="mb-4 text-2xl font-bold">About the Property</h2>
	<p class="text-gray-700">
		{propertyDescription}
	</p>
</div>
